/**
 * The column headings of every case review table.
 *
 * Its own module because both users would otherwise import each other: the section renderer draws
 * the head above a form, and the record list draws it above the cards that contain those forms.
 */
export const CASE_REVIEW_TABLE_HEAD = ["Field", "Value", "AI confidence", "Action"] as const;

/**
 * The same table with nothing extracted in it.
 *
 * <p>A record a reviewer typed in has no AI values, and two permanently empty columns on every row
 * of it read as something missing rather than as something that never existed.
 */
export const CASE_REVIEW_TABLE_HEAD_PLAIN = ["Field", "Value"] as const;
